import React, { useState, useEffect, useRef } from "react";
import { useQuery, useDetail, useSave } from "seed/gql";
import { useGetCall, usePost, useGet } from "seed/api";
import { Loading } from "seed/helpers";
import Chat from "components/presentation/chat/Chat"
import { SAVE_CHAT_MESSAGE } from "seed/gql/queries";

const ChatStudio = ({
  flowId,
  match
}) => {

  const urlParams = new URLSearchParams(window.location.search);
  const rootNodeId = urlParams.get("root_node_id");

  const chatRef = useRef(null);
  const [chat, setChat] = useState(null);

  const [callExecute] = usePost("/flows/execute_node");

  const [callMessage] = useSave(SAVE_CHAT_MESSAGE, {
    onCompleted: (data) => {
      if (!data) return;
      callExecute({
        is_debug: true,
        root_node_id: rootNodeId,
        flow_id: flowId,
        message_id: data.saveChatMessage.chatMessage.id,
        session_id: sessionStorage.getItem("execution_session_id")
      });
    }
  });

  const [callInitChat] = usePost("/chats/init_web_chat", {
    onCompleted: (data) => {
      setChat(data);
    },
  });

  const reqFlow = useDetail(`{
    flow {
      name
      description
      token
      settings
      participants {
        role {
          name
        }
        user {}
      }
      user {
        email
        accountSettings
      }
    }
  }`, flowId);

  const reqNode = useDetail(`{
      flowNode {
        rootName
        rootDescription
        rootSettings
      }
    }`, rootNodeId);

  const { flow = {} } = reqFlow.data;
  const { flowNode = {} } = reqNode.data;

  useEffect(() => {
    if (!flow || chat) return;
    callInitChat({ flow_id: flow?.id, is_debug: true });
  }, [flow]);

  useEffect(() => {
    if (!chat) return;
      callMessage({
        type: "USER_MESSAGE",
        isTemplate: false,
        templateName: "",
        responseRequired: false,
        content: {},
        action: {},
        settings: { visible: false },
        chat: { id: chat.id },
      });
  }, [chat]);

  if(!chat || !flow || !flowNode) return <Loading />;

  return (
    <div id="chat-studio-container" className="card h-100">
      <div className="card-body p-1 h-100">
        <Chat
          ref={chatRef}
          flow={flow}
          chat={chat}
          currentChat={chat}
          isExecutionChat={true}
        />
      </div>
    </div>
  );
}

export default ChatStudio;